var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8 1.4a1.4 1.4 0 00-1.4 1.4v10.4a1.4 1.4 0 001.4 1.4h5.869a1.4 1.4 0 00.99-.41l2.53-2.531a1.4 1.4 0 00.41-.99v-.658L13.6 10V2.8a1.4 1.4 0 00-1.4-1.4H3.8zm8.6 8V2.8a.2.2 0 00-.2-.2H3.8a.2.2 0 00-.2.2v10.4c0 .11.09.2.2.2h4.6v-2.6a1.4 1.4 0 011.4-1.4h2.6zm-2.8 4h.069a.2.2 0 00.141-.059l2.531-2.531a.2.2 0 00.059-.141v-.07H9.8a.2.2 0 00-.2.2V13.4z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/draft_folder.8e863c38.svg";
export { SvgDraftFolder as ReactComponent };